/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_CanvasInputs */

const cs_workflow_canvas = /** @type {(inputs: Workflow_CanvasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plátno workflow`)
};

const en_workflow_canvas = /** @type {(inputs: Workflow_CanvasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow canvas`)
};

/**
* | output |
* | --- |
* | "Workflow canvas" |
*
* @param {Workflow_CanvasInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_canvas = /** @type {((inputs?: Workflow_CanvasInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_CanvasInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_canvas(inputs)
	return cs_workflow_canvas(inputs)
});